(function($, App, Utils, Components){
  'use strict';

  const logger = new Logger("ReadMore");

  Components.create('ReadMore', {

    countWords: str => str.split(/\s+/).length,

    ellipseContent: (str, wordsNum) => {
      return str.split(/\s+/).slice(0, wordsNum).join(' ') + '...';
    },

    truncateText: function() {
      Array.from(this.content).map((content, i) => {
        const originalContent = content.innerHTML;
        const numberOfWords = content.dataset.rmWords;
        const originalContentWords = this.countWords(originalContent);
        if (originalContentWords > numberOfWords) {
          const truncateContent = this.ellipseContent(originalContent, numberOfWords);
          this.originalContentArr.push(originalContent);
          this.truncatedContentArr.push(truncateContent);
          content.innerHTML = truncateContent;
          content.setAttribute("role", "tabpanel")
          content.setAttribute("id", `expanded-panel-${i}`)

          this.createLink(i);
        }
        return this.handleClick(content);
      });
    },
    createLink: function(index) {
      const linkWrap = document.createElement('span');

      linkWrap.className = 'read-more__link-wrap';

      linkWrap.innerHTML = `<button id="read-more_${index}"
                                class="read-more__link"
                                aria-label="${this.moreLink}"
                                aria-expanded="false"
                                role="tab" 
                                aria-controls="expanded-panel-${index}" 
                                aria-selected="false"
                                >
                                ${this.moreLink}
                            </button>`;

      this.content[index].parentNode.insertBefore(linkWrap, this.content[index].nextSibling);
    },

    handleClick: function(el) {
      const _this = this;
      const readMoreLink = el.nextElementSibling;

      if (readMoreLink) {
        const link = readMoreLink.querySelector('.read-more__link');
        if (link) {
          link.addEventListener('click', function() {
            const moreLinkID = this.getAttribute('id');
            const index = moreLinkID.split('_')[1];
            this.classList.toggle('is-expanded');

            if (this.dataset.clicked !== 'true') {
              el.innerHTML = _this.originalContentArr[index];
              this.innerHTML = _this.lessLink;
              this.dataset.clicked = 'true';
              this.setAttribute("aria-selected", "true");
              this.setAttribute("aria-expanded", "true")
            } else {
              el.innerHTML = _this.truncatedContentArr[index];
              this.innerHTML = _this.moreLink;
              this.dataset.clicked = 'false';
              this.setAttribute("aria-selected", "false");
              this.setAttribute("aria-expanded", "false")
            }
          });
        }
      }
    },
    bindEvents: function() {
      this.originalContentArr = [];
      this.truncatedContentArr = [];
      this.moreLink = this.content[0].dataset.moreLabel;
      this.lessLink = this.content[0].dataset.lessLabel;

      this.truncateText();
    },
    init: function() {
      this.content = document.querySelectorAll('.js-read-more');

      if (this.content.length < 1) return;

      this.bindEvents();
    }
  });

})(jQuery, window.App, window.App.Utils, window.App.Components);